import React from 'react'
import Main from '../../Layout/Main'
import Tittle from '../../Components/about/Tittle'
import AboutSection from '../../Components/about/AboutSection'
import FunFact from '../../Components/about/FunFact'
import Features from '../../Components/about/Features'
import Testimonail from '../../Components/about/Testimonail'
import CallAction from '../../Components/about/CallAction'
import Client from '../../Components/about/Client'
import Subscribe from '../../Components/about/Subscribe'

const About = () => {
  return (
    <Main>
      <Tittle/>
      <AboutSection/>
      <FunFact/>
      <Features/>
      <Testimonail/>
      <CallAction/>
      <Client/>
      <Subscribe/>
    </Main>
  )
}

export default About